<template>
<div>
  <vue-headful :title="site_title" />
  <div class="ratings_page">
    Рейтинг жителя<br><br>
    <template v-if="this.response">
      <template v-if="this.response.ratings.length > 0">
        <table>
          <th>Житель</th>
          <th>Оценен</th>
          <th>Оценка</th>
          <th>Комментарий</th>
          <tr v-for="rating in this.response.ratings">
            <td width="200px"><a :href="'index.php?act=Rate&id='+rating.id">{{htmlDecode(rating.name)}}</a></td>
            <td width="200px">{{rating.ratedate | formatRusDateLong}}</td>
            <td width="70px">{{rating.rating}}</td>
            <td>{{htmlDecode(rating.comment)}}</td>
          </tr>
        </table>
      </template>
      <template v-else>Рейтингов нет</template>
    </template>
    <!--
  <template v-if="this.response">
    <div style="display: flex; justify-content: center;">
      <table>
        <tr v-for="emoji in this.response.emojis">
          <td style="text-align: center; width: 50px;">{{emoji.typed}} </td>
          <th style="width: 100px;">{{emoji.image}} </th>
          <td style="text-align: center; width: 50px;"><img :src="'html/emoticons/' + (emoji.image)" /></td>
        </tr>
      </table>
    </div>
  </template>
-->
  </div>
</div>
</template>

<script>
import {
  globalRusDate
} from '../../public/utils.js';

export default {
  components: {},
  data: function() {
    return {
      response: null
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let memberId = 0;
    if (this.$route.query.id) {
      memberId = this.$route.query.id;
    }
    let response = await fetch(this.getNodePath() + 'misc/ratings/' + memberId);
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    console.timeEnd("PageLoadTime");
  }
}
</script>

<style lang="scss">
.ratings_page {
    text-align: center;
    table {
        background-color: #20194b;
    }
    th {
        background-color: #1b153b;
    }
}
</style>
